// The breakpoints of spec 6.12 (design 15.2), as hooks that follow the viewport live.
import { useSyncExternalStore } from 'react';

export const BREAKPOINTS = {
  /** Below this the phone layout applies. */
  phone: 768,
  /** Below this the rail shows icons only and the designer's inspector is a drawer. */
  compact: 1024,
  /** Below this the designer's palette is collapsed by default. */
  medium: 1200,
  /** Below this the designer's inspector is 320 px. */
  wide: 1440,
} as const;

export const PHONE_QUERY = `(max-width: ${BREAKPOINTS.phone - 0.02}px)`;
export const COMPACT_QUERY = `(max-width: ${BREAKPOINTS.compact - 0.02}px)`;
export const MEDIUM_QUERY = `(max-width: ${BREAKPOINTS.medium - 0.02}px)`;

export function matchesMedia(query: string): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(query).matches
  );
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window.matchMedia !== 'function') return () => {};
      const list = window.matchMedia(query);
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    () => matchesMedia(query),
    () => false,
  );
}

/** Below 768 px: the phone layout. */
export const usePhone = () => useMediaQuery(PHONE_QUERY);

/** Below 1024 px: rail icons only, folded docks, the inspector as a drawer. */
export const useCompact = () => useMediaQuery(COMPACT_QUERY);

/** Below 1200 px: the palette collapsed by default. */
export const useMedium = () => useMediaQuery(MEDIUM_QUERY);
